import { useQuery } from "@tanstack/react-query";
import { useAuth as useClerkAuth, useUser } from "@clerk/react";
import type { User } from "@shared/schema";
import { getQueryFn } from "@/lib/queryClient";

export function useAuth() {
  const { isLoaded, isSignedIn } = useClerkAuth();
  const { user: clerkUser } = useUser();
  const appUserQuery = useQuery<User | null>({
    queryKey: ["/api/me"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    enabled: isLoaded && isSignedIn,
    retry: false,
  });

  const appUser = appUserQuery.data;
  const user = clerkUser && appUser
    ? {
        ...appUser,
        email: clerkUser.primaryEmailAddress?.emailAddress ?? appUser.email,
        firstName: clerkUser.firstName ?? appUser.firstName,
        lastName: clerkUser.lastName ?? appUser.lastName,
        profileImageUrl: clerkUser.imageUrl ?? appUser.profileImageUrl,
      }
    : appUser;

  return {
    user,
    isLoading: !isLoaded || (isSignedIn && appUserQuery.isLoading),
    isAuthenticated: Boolean(isSignedIn),
    isAdmin: appUser?.isAdmin ?? false,
  };
}